export default "__VITE_ASSET__BHMhivki__"